import { render, staticRenderFns } from "./ValidationEmail.vue?vue&type=template&id=5a22ad10&scoped=true"
import script from "./ValidationEmail.vue?vue&type=script&lang=js"
export * from "./ValidationEmail.vue?vue&type=script&lang=js"
import style0 from "./ValidationEmail.vue?vue&type=style&index=0&id=5a22ad10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22ad10",
  null
  
)

export default component.exports